var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIndicator = function SvgWarningIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    d: "M1.667 15.875h12.666a1 1 0 0 0 .883-1.47L8.882 2.528a1 1 0 0 0-1.764 0L.784 14.404a1 1 0 0 0 .883 1.471"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.503 11.408 7.05 5.875h1.892l-.426 5.533zm-.392 2.467v-1.726h1.765v1.726z"
  })));
};
export default SvgWarningIndicator;